import * as IoC from 'inversify';
import { registerCommand, registerQuery } from '@/app/tracking/api';
import { AddQuestionAttemptsTrackingCommandName, QueryQuestionAttemptsTrackingQueryName } from '../api'
import { QuestionAttemptsSuspendDataStore, questionAttemptCommonTrackingModule } from '../common';
import { Scorm2004AddQuestionAttemptsCommandHandler } from './scorm2004-add-question-attempts-command-handler'
import { Scorm2004QueryQuestionAttemptsQueryHandler } from './scorm2004-query-question-attempts-query-handler';

const questionAttemptScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(AddQuestionAttemptsTrackingCommandName, Scorm2004AddQuestionAttemptsCommandHandler, bind);
  registerQuery(QueryQuestionAttemptsTrackingQueryName, Scorm2004QueryQuestionAttemptsQueryHandler, bind);
  bind(QuestionAttemptsSuspendDataStore).toSelf().inSingletonScope()
})

export const questionAttemptScorm2004TrackingModules = [
  questionAttemptScorm2004TrackingModule,
  questionAttemptCommonTrackingModule
]
